import { Card as ForecastAlertCard } from "../../components/ForecastCard";
import { InventoryCard } from "../../components/InventoryCard";
import { AlertData, AlertType, InventoryAlertData, InventoryAlertType } from "../../services/interface/IAlerts";
import { CardInfo, IPredectivePayload, IModuleCard } from "../../services/interface/IHome";
import { ModuleCard } from "../../components/ModuleCard";
import { useState, useEffect } from "react";
import { Loader } from "rsuite";
import { useGBPAlerts, useGBPFilters, useInventoryAlerts } from "../../services/redux/hooks/useHome";
import { useDispatch } from "react-redux";
import { setApplyForecastFilter, setFilter, setLastUpdatedDate } from "../../services/redux/reducer/filter.reducer";
import { setMapDC, setMapStore, setSelectedFlagMarker } from "../../services/redux/reducer/demandfilter.reducer";
import CustomLoader from "../../common/CustomLoader/CustomLoader";
import LineOfBusinessModal from "../../components/LineOfBusinessModal";
import { useGetDropdownPopupMutation } from "../../services/redux/api/homeApi";

const moduleInfo: IModuleCard[] = [
    {
        title: "Demand Forecasting",
        options: ["Forecast Overview", "Forecast Deep Dive", "Forecast Segmentation", "Feature Importance", "Accuracy Deep Dive"]
    },
    {
        title: "Promotions Assessment",
        options: ["Cannibalization", "Ad Effectiveness", ""]
    },
    {
        title: "Inventory & Replenishment",
        options: ["On Hand vs Target", "Inventory and SOQ", ""]
    },
    {
        title: "Collaborative Planning",
        options: ["POS vs Shipped", "Consensus Planning", ""]
    },
]
let modalDisplayed = false;

const Home = () => {
    const [showModal, setShowModal] = useState(!modalDisplayed);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [userName, setUserName] = useState<string | null>(localStorage.getItem("name"));
    const [gbpPayload, setgbpPayload] = useState<IPredectivePayload>({
        adjustedLogic: [],
        alerts: [],
        clustername: [],
        futureSegmentation: [],
        l2: [],
        l3: [],
        material: [],
        materialDescription: [],
        mrpType: [],
        plant: [],
        poAlert: [],
        reviewedFlag: [],
        vendorName: [],
    });
    const [alertsData, setAlertsData] = useState<AlertData>();
    const [inventoryData, setInventoryData] = useState<InventoryAlertType[]>();
    const { mutate, isError, error, isSuccess, data: resdata } = useGBPAlerts();
    const { mutate: mutateInventory, isError: isErrorInventory, error: errorInventory, isSuccess: isSuccessInventory, data: resInventory } = useInventoryAlerts();
    const { mutate: mutateFilters } = useGBPFilters();
    const [dropdownData, setDropdownData] = useState([]); 
    const [getPopupData, { isLoading }] = useGetDropdownPopupMutation();
    const [healthcareValue, setHealthcareValue] = useState<string>(localStorage.getItem('healthcareValue') || "0");

    const moduleInfo: IModuleCard[] = [
        {
            title: "Demand Forecasting",
            options: ["Forecast Overview", "Forecast Deep Dive", "Forecast Segmentation", "Feature Importance", "Accuracy Deep Dive"]
        },
        {
            title: "Promotions Assessment",
            options: healthcareValue === "1" ? ["Cannibalization", "Ad Effectiveness"] : ["Ad Effectiveness"]
        },
        {
            title: "Inventory & Replenishment",
            options: ["On Hand vs Target", "Inventory and SOQ", ""]
        },
        {
            title: "Collaborative Planning",
            options: ["POS vs Shipped", "Consensus Planning", ""]
        },
    ]
      useEffect(() => {
         if (showModal && !modalDisplayed) {
          modalDisplayed = true;
          fetchDropdownData();
        }
      }, [showModal]);

    useEffect(() => {
        const fetchAlerts = async () => {
            try {
                await mutate(gbpPayload).unwrap();
                await mutateInventory(gbpPayload).unwrap();
                await mutateFilters(gbpPayload).unwrap();
            } catch (err) {
                console.error("Failed to fetch alerts: ", err);
            }
        };
        fetchAlerts();
    }, []);

    useEffect(() => {
        setLoading(true);
        if (resdata && isSuccess) {
            setAlertsData(resdata);
            setLoading(false);
        }
    }, [resdata]);

    useEffect(() => {
        setLoading(true);
        if (resInventory && isSuccessInventory) {
            setInventoryData(resInventory?.data?.result);
            setLoading(false);
        }
    }, [resInventory]);

    useEffect(() => {
        if (loading) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [loading]);

    useEffect(()=>{
        dispatch(setApplyForecastFilter({"status":false, "rowNo":-1}));
        // Clearing Map
        dispatch(setSelectedFlagMarker({"location":[],"status":false}));
        dispatch(setMapDC([]));
        dispatch(setMapStore([]));
    },[]);
    
    const handleModalSubmit = async ({
        selectedValue,
        selectedLabel,
        selectedInd,
    }: {
        selectedValue: string | null;
        selectedLabel: string | null;
        selectedInd: number | null;
    }) => {
        if (!selectedValue || !selectedLabel) {
            return;
        }
    
        console.log("Modal Submit - Selected Label:", selectedLabel);
        
        try {
            // First, update the healthcare value if the selected item is Healthcare
            const isHealthcare = selectedLabel === "Wholesale Distributors";
            const healthcareValue = isHealthcare ? "1" : "0";
            
            console.log("Setting healthcare value to:", isHealthcare ? "1" : "0");
            localStorage.setItem('healthcareValue', healthcareValue);
            
            // Then make the API call
            const response = await getPopupData({
                selectedLable: selectedLabel,
                selectedLableValue: "1",   // Always send 1 to mark as selected
                isStoreProcData: true
            }).unwrap();
    
            console.log("API Response on Modal Submit:", response);
    
            // Trigger storage event to update navbar
            window.dispatchEvent(new Event('storage'));
            
            // Refresh dropdown data
           // await fetchDropdownData();
        } catch (error) {
            console.error("Error submitting dropdown value:", error);
        } finally {
            setShowModal(false); // Close modal on success
        }
    };
    
    // Update fetchDropdownData to handle healthcare status properly
    const fetchDropdownData = async () => {
        try {
            const response = await getPopupData({
                selectedLableValue: "",
                selectedLable: "",
                isStoreProcData: false
            }).unwrap();
    
            console.log("Fetch Response Data:", response?.data);
    
            // Check for Healthcare in the response
            const healthcareData = response?.data.find((item: { lable: string; value: number }) => 
                item.lable === "Wholesale Distributors"
            );
    
            // Update healthcare value based on API response
            if (healthcareData) {
                const newValue = healthcareData.value === 1 ? "1" : "0";
                console.log("API Healthcare Value:", newValue);
                localStorage.setItem('healthcareValue', newValue);
                setHealthcareValue(newValue)
                // Trigger storage event to notify components of the change
                window.dispatchEvent(new Event('storage'));
            }
    
            // Map dropdown data
            setDropdownData(
                response?.data.map((item: { value: string; lable: string; }) => ({
                    value: item.value,
                    label: item.lable,
                }))
            );
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        }
    };
    
      
      
    

    return <>
        <div className="w-full flex flex-col h-full">
            <div className="flex flex-col basis-[45vh] grow p-[2%] py-[1.5vh] db-main">
                <div>
                    <h1 className="py-[0px] text-fs32 leading-normal text-white">Welcome, <span className="font-bold primary">{userName}</span></h1>
                </div>
                <div className="grid grid-cols-2 gap-3">
                    <div>
                        <h2 className="home-page-alerts font-normal mb-2 text-white">Forecast Alerts</h2>
                        <div className="grid grid-cols-3 gap-2">
                            {alertsData?.shortTerm?.map((item: AlertType, index: number) => {
                                return <ForecastAlertCard key={index} card={item}></ForecastAlertCard>
                            })}
                        </div>
                    </div>
                    <div>
                        <h2 className="home-page-alerts font-normal mb-2 text-white">Inventory Alerts</h2>
                        <div className="grid grid-cols-3 gap-2">
                            {inventoryData?.filter((item: InventoryAlertType) => ["Overstock2", "Stockout2", "Inactive3"].includes(item.title))
                                .sort((a: InventoryAlertType, b: InventoryAlertType) => {
                                    const order = ["Overstock2", "Stockout2", "Inactive3"];
                                    return order.indexOf(a.title) - order.indexOf(b.title);
                                })
                                .map((item: InventoryAlertType, index: number) => {
                                    return <InventoryCard key={index} card={item} />;
                                })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex basis-[42vh] grow p-[2%] pt-[0.5%] pb-[1vh] bg-[#F1F1F1]">
                <div className="w-full">
                    <h2 className="home-page-footer mb-2">Your Planning Tools</h2>
                    <div className="grid grid-cols-4 gap-4">
                        {moduleInfo.map((module: IModuleCard, index: number) => {
                            return <ModuleCard key={index} module={module} />
                        })}
                    </div>
                </div>
            </div>
        </div>
        {!loading && (
        <LineOfBusinessModal
          open={showModal}
          onClose={() => setShowModal(false)}
          onSubmit={handleModalSubmit}
          dropdownData={dropdownData}
        />
      )}                
        {loading && <CustomLoader open={loading}/>}
    </>
}

export default Home;